import { getTextColor } from '@/utils/colorHelpers.js';

// Shared heights of the dark hero band so the hero and content below it stay in sync.
export const DARK_HERO_BAND_HEIGHT = 300;
export const DARK_HERO_BAND_HEIGHT_MOBILE = 420;

// Readable foreground for anything sitting on the secondary band, which varies per customer.
export const onBandColor = (theme: any) =>
    getTextColor(theme.palette.common.secondary, theme.palette.common.darkGrey, theme.palette.common.white);

// Readable foreground for anything sitting on the primary colour, which varies per customer.
export const onPrimaryColor = (theme: any) =>
    getTextColor(theme.palette.common.yellow, theme.palette.common.darkGrey, theme.palette.common.white);
